module.exports = __webpack_public_path__ + "img/public/siteImages/reviews.svg?0909ba0b";